// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingB_heading__TNlwb"};